import state from './moduleBannerState.js'
import mutations from './moduleBannerMutations.js'
import actions from './moduleBannerActions.js'
import getters from './moduleBannerGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
